import { render, staticRenderFns } from "./Attorney.vue?vue&type=template&id=046009c4&scoped=true&"
import script from "./Attorney.vue?vue&type=script&lang=js&"
export * from "./Attorney.vue?vue&type=script&lang=js&"
import style0 from "./Attorney.vue?vue&type=style&index=0&id=046009c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046009c4",
  null
  
)

export default component.exports